import { IExportPlugin, PluginType } from '@/version-types';
import { default as mouseOperateActivePlugin } from './active/active-plugin';
import { default as mouseOperateHoverPlugin } from './hover/plugin';
import { MouseOperate } from './mouse-operate';
import { default as mouseOperatePickPlugin } from './pick/plugin';

export { MouseHover } from './hover/hover';
export { MouseOperate } from './mouse-operate';
export {
    SnapCandidateResolver,
    type MouseOperateEventListener,
    type MoveAfterUpdateEvent,
    type MoveBeforeUpdateEvent,
    type MoveEndEvent,
    type MoveSnapSlot,
    type MoveStartEvent,
    type ResizeAfterUpdateEvent,
    type ResizeBeforeUpdateEvent,
    type ResizeEndEvent,
    type ResizeSnapSlot,
    type ResizeStartEvent,
    type RotateAfterUpdateEvent,
    type RotateBeforeUpdateEvent,
    type RotateEndEvent,
    type RotateStartEvent,
    type ScaleAfterUpdateEvent,
    type ScaleBeforeUpdateEvent,
    type ScaleEndEvent,
    type ScaleStartEvent,
    type SnapCandidate,
    type SnapCandidateCollector,
    type SnapSlot,
    type SnapSource,
} from './operation-events';

export const mouseOperatePlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 2,
    name: 'mouse-operate',
    dependencies() {
        return [
            { plugin: mouseOperateActivePlugin },
            { plugin: mouseOperateHoverPlugin },
            { plugin: mouseOperatePickPlugin },
        ];
    },
    createInstance({ identity }) {
        return [{ key: 'MouseOperate', value: new MouseOperate(identity) }];
    },
};

export default mouseOperatePlugin;
